import ContentWrapper from "./styles";

const Content = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
  return <ContentWrapper>{children}</ContentWrapper>;
};

export default Content;
